import { render, staticRenderFns } from "./login-by-phone.vue?vue&type=template&id=6896d3b2&"
import script from "./login-by-phone.vue?vue&type=script&lang=js&"
export * from "./login-by-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports